import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { PhotoSeriesDamages } from '../../../../../../components';
import { selectors as damagesSelectors } from '../../../../../../redux/damages';
import { selectors as customerSelectors } from '../../../../../../redux/customers';

const PhotoSeriesDamagesSection = ({ isLoadingPhotoSeries, photoSeries }) => {
  const damages = useSelector((state) => damagesSelectors.selectPhotoSeriesDamages(state, photoSeries?.id));
  const customer = useSelector(customerSelectors.selectCurrentCustomer);

  const PhotoSeriesQualityRatingProps = {
    isLoadingPhotoSeries,
    photoSeries,
    damages,
    vehicleType: photoSeries.workflow.vehicleType,
    customer
  };

  return <PhotoSeriesDamages {...PhotoSeriesQualityRatingProps} />;
};

PhotoSeriesDamagesSection.propTypes = {
  isLoadingPhotoSeries: PropTypes.bool.isRequired,
  photoSeries: PropTypes.object
};

export default PhotoSeriesDamagesSection;
